import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
  HTMLAttributes,
} from 'react';

import { Container, Content } from './styles';

interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export interface ModalHandles {
  open(): void;
  close(): void;
}

const Modal: React.ForwardRefRenderFunction<ModalHandles, ModalProps> = (
  { children, ...rest },
  ref,
) => {
  const [visible, setVisible] = useState(false);

  const open = useCallback(() => {
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return visible ? (
    <Container>
      <Content {...rest}>{children}</Content>
    </Container>
  ) : null;
};

export default forwardRef(Modal);
